import { render } from "./CookiesDropDown.vue?vue&type=template&id=19a96cfc&scoped=true"
import script from "./CookiesDropDown.vue?vue&type=script&lang=js"
export * from "./CookiesDropDown.vue?vue&type=script&lang=js"

import "./CookiesDropDown.vue?vue&type=style&index=0&id=19a96cfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a96cfc"]])

export default __exports__